import { create } from "zustand"

export const useDataStore = create((set, get) => ({
    API_URL: "/api/data",
    data: [],

    hasExpired: (fetchDay) => {
        if (!fetchDay) return true
        const today = new Date().getDate().toString()
        return fetchDay !== today
    },

    fetchData: async () => {
        try {
            const storedData = localStorage.getItem("companyData")
            const storedFetchDay = localStorage.getItem("fetchDay")

            if (storedData && !get().hasExpired(storedFetchDay)) {
                const companyData = JSON.parse(storedData)
                const dataFix = Array.isArray(companyData)
                    ? companyData
                    : companyData.data
                set({ data: dataFix })
                return
            }

            const res = await fetch(get().API_URL).then((res) => res.json())

            const dataFix = Array.isArray(res) ? res : res.data
            set({ data: dataFix })
            localStorage.setItem("companyData", JSON.stringify(res))
            localStorage.setItem("fetchDay", new Date().getDate().toString())
        } catch (error) {
            console.error("Could not set data : " + error)
        }
    },
}))
